import React, { useState, useEffect } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import MaterialButton from "../../../../components/MaterialButton";
import colors from "../../../../assest/theme/base/colors";
import { Box, Dialog } from "@mui/material";
import DynamicTable from "../../../Utils/DynamicTable";
import Addwallet from "./add";
import ConfirmDialog from "../../../Utils/ConfirmDialog";
import MessagePopup from "../../../Utils/MessagePopup";
import TableActionItems from "../../../../components/tabel/components/actionItems";
import TanstackTableComponents from "../../../../components/tabel";
import { useSnackbar } from "../../../../components/SnackbarProvider";
import { useLoading } from "../../../../context/loadingcontext";
import axiosInstance, { API_URL } from "../../../Utils/url";
// import LoadingSpinner from "../../loader/loadercomp";

function Wallet() {
  const [open, setOpen] = useState(false);
  const [view, setview] = useState(false);
  const [searchdata, setsearchdata] = useState("");
  const [editeddata, setEditeddata] = useState([]);
  const [editedtrue, setEditedtrue] = useState(false);
  const [dialogData, setDialogData] = useState({
    title: "",
    content: "",
    onConfirm: () => {},
  });
  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [userlist, setuserlist] = useState([]);
  const [openExport, setOpenExport] = useState(false);
  const [Loader, setLoader] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [walletList, setWalletList] = useState([]);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [formType, setFormType] = useState(null);

  const [rowId, setRowId] = useState(null);
  const [tableLoading, setTableLoading] = useState(false);
  const { showSnackbar } = useSnackbar();
  const { setCirleLoading } = useLoading();
  const [tabelCounts, setTabelCounts] = useState({
    totalItems: 0,
    totalPages: 0,
  });
  const columns = [
   
    {
      header: "Insurance Name",
      accessorKey: "insurance_name",
      cell: (props) => <p>{props.getValue()}</p>,
      meta: {
        sticky: true,
        left: 0,
      },
    },
     {
      header: "Company Name",
      accessorKey: "company",
      cell: (props) => <p>{props.getValue()}</p>,
      meta: {
        sticky: true,
        left: 150,
      },
    },
    {
      header: "Wallet Amount",
      accessorKey: "wallet_amount",
      cell: (props) => <p>₹{props.getValue()}</p>,
    },
    {
      header: "Transaction no",
      accessorKey: "transaction_no",
      cell: (props) => <p>{props.getValue()}</p>,
    },
    {
      header: "Actions",
      accessorKey: "actions",
      cell: (props) => (
        <TableActionItems
          row={props}
          onView={onView}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      ),
    },
  ];

  useEffect(() => {
    fetchWalletConfig(pagination.pageIndex + 1);
  }, [pagination, open]);

  const fetchWalletConfig = async (pageNumber, searchText) => {
    setTableLoading(true);
    try {
      const response = await axiosInstance.get(
        `${API_URL}v1/wallet-configuration/?page=${pageNumber}`
      );

      const success = response?.data?.success;
      const message = response?.data?.message;
      if (success) {
        setWalletList(response?.data?.data);
      } else {
        setWalletList([]);
      }
      setTabelCounts({
        totalItems: response?.data?.total_items,
        totalPages: response?.data?.total_pages,
      });
    } catch (err) {
      setWalletList([]);
    } finally {
      setTableLoading(false);
    }
  };

  const formClose = () => {
    setOpen(false);
    setview(false);
  };
  const addRole = () => {
    setOpen(true);
    setFormType("add");
  };

  const onView = (row) => {
    setRowId(row?.id);
    setFormType("view");
    setOpen(true);
  };

  const onDelete = (row) => {
    console.log(row?.id, "valuess");
    deletelist(row?.id);
  };

  const onEdit = (row) => {
    setRowId(row?.id);
    setOpen(true);
    setFormType("edit");
  };

  const deletelist = (id) => {
    handleOpenDialog();
    setDialogData({
      title: "Are you sure you want to delete this records ?",
      content: `If you delete the field you can’t recover it`,
      onConfirm: () => deleteconfirm(id),
      onClose: () => deletecancel(),
    });
  };

  const deleteconfirm = async (id) => {
    deletecancel();
    setCirleLoading(true);
    try {
      const response = await axiosInstance.delete(
        `${API_URL}v1/wallet-configuration/${id}/`
      );
      showSnackbar(response?.data?.message, "success");
    } catch (err) {
      showSnackbar(err?.response?.data?.message, "error");
    } finally {
      setCirleLoading(false);
      fetchWalletConfig(pagination.pageIndex + 1);
    }
  };

  const deletecancel = () => {
    setDialogOpen(false);
    setDialogData({
      ...dialogData,
      title: "",
      content: "",
      onConfirm: () => {},
    });
  };

  //open and close dialog for confirmation
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  return (
    <DashboardLayout
      searchdata={searchdata}
      setsearchdata={setsearchdata}
      setOpenExport={setOpenExport}
      name="Position Master"
    >
      {/* {Loader && <LoadingSpinner />} */}
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      <ConfirmDialog
        open={dialogOpen}
        title={dialogData.title}
        content={dialogData.content}
        onClose={handleCloseDialog}
        onConfirm={dialogData.onConfirm}
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end", width: "98%" }}>
        <Dialog
          open={open}
          sx={{
            "& .MuiDialog-paper": {
              width: "800px", // Set your desired width
              maxWidth: "none", // Prevent it from limiting the width to default sizes
            },
          }}
        >
          <Addwallet
            formClose={formClose}
            formType={formType}
            setOpen={setOpen}
            rowId={rowId}
          />
        </Dialog>
      </Box>

      <TanstackTableComponents
        rows={walletList}
        columns={columns}
        pageCount={tabelCounts.totalPages}
        recordCount={tabelCounts.totalItems}
        addTitle="Add Insurance"
        heading="Wallet Config List"
        isLoading={tableLoading} // loading enable
        isMore={false} // More options Enable
        isExport={true} // export options enable
        isUpload={true} // upload options enable
        isAdd={true} // add option enable
        isDateFilter={false} // date filter enable
        isSearch={true} // seacrh enable
        pagination={pagination}
        setPagination={setPagination}
        handleAdd={addRole}
      />
    </DashboardLayout>
  );
}

export default Wallet;
